module.exports = __webpack_public_path__ + "media/images/favorite-icon-f6a0e779cea548ff9a9a4f82cc7df2c3.png";